import { render } from "./BuilderEstimatorSummaryDesktop.vue?vue&type=template&id=1047c965&scoped=true&ts=true&lang=pug"
import script from "./BuilderEstimatorSummaryDesktop.vue?vue&type=script&lang=ts&setup=true"
export * from "./BuilderEstimatorSummaryDesktop.vue?vue&type=script&lang=ts&setup=true"

import "./BuilderEstimatorSummaryDesktop.vue?vue&type=style&index=0&id=1047c965&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1047c965"]])

export default __exports__